import AccountsSalesDashboard from "../components/dashboardComponents/AccountsSalesDashboard";
import AccountsPurchaseDashboard from "../components/dashboardComponents/AccountsPurchaseDashboard";
import SellerSalesDashboard from "../components/dashboardComponents/SellerSalesDashboard";
import TransportManagerDashboard from "../components/dashboardComponents/Transportmanagerdashboard";
import CareDashboard from "../components/dashboardComponents/Caredashboard";
import Dashboard from "../pages/Dashboard";

function CommonDashboard() {
    const adminInfo = localStorage.getItem("adminInfo")
        ? JSON.parse(localStorage.getItem("adminInfo"))
        : null;

    const profileId = adminInfo?.id_profile;

    if (!profileId) return <p>No user logged in</p>;
    if (profileId === 32) {
        return <AccountsSalesDashboard />;
    }
    else if (profileId === 33) {
        return <AccountsPurchaseDashboard />;
    }
    else if (profileId === 3) {
        return <SellerSalesDashboard />;
    }
    else if (profileId === 2) {
        return <TransportManagerDashboard />;
    }
    else if (profileId === 4) {
        return <CareDashboard />;
    }
    else {
        return <Dashboard />;

    }

}

export default CommonDashboard;